// Test Full Dataset Loading
// Run this in browser console to test the loading process

export const testFullDatasetLoading = async () => {
  console.log('🧪 TESTING FULL DATASET LOADING...');
  console.log('=====================================');
  
  try {
    // Test 1: Check if JSON file is accessible
    console.log('📡 Test 1: Checking JSON file accessibility...');
    const response = await fetch('/events_master_with_format_and_geo.json');
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    console.log('✅ JSON file accessible');
    
    // Test 2: Check file size
    const contentLength = response.headers.get('content-length');
    console.log(`📊 File size: ${contentLength ? (parseInt(contentLength) / 1024 / 1024).toFixed(2) + ' MB' : 'Unknown'}`);
    
    // Test 3: Parse JSON
    console.log('📄 Test 2: Parsing JSON...');
    const rawData = await response.json();
    console.log(`✅ JSON parsed successfully: ${rawData.length} events`);
    
    // Test 4: Check data structure
    console.log('🔍 Test 3: Checking data structure...');
    const sampleEvent = rawData[0];
    console.log('Sample event structure:', {
      hasTitle: !!sampleEvent.event_title,
      hasDescription: !!sampleEvent.description,
      hasStartTime: !!sampleEvent.start_time,
      hasLocation: !!sampleEvent['location/address'],
      hasFormat: !!sampleEvent.format,
      hasLatitude: !!sampleEvent.latitude,
      hasLongitude: !!sampleEvent.longitude
    });
    
    // Test 5: Check event distribution
    console.log('📈 Test 4: Checking event distribution...');
    const formats = rawData.reduce((acc, event) => {
      acc[event.format] = (acc[event.format] || 0) + 1;
      return acc;
    }, {});
    
    console.log('Format distribution:', formats);
    
    // Test 6: Check date range
    console.log('📅 Test 5: Checking date range...');
    const dates = rawData.map(event => event.start_time).filter(date => date);
    const uniqueDates = [...new Set(dates)];
    console.log(`Date range: ${uniqueDates.length} unique dates`);
    console.log('Sample dates:', uniqueDates.slice(0, 5));
    
    // Test 7: Performance test
    console.log('⚡ Test 6: Performance test...');
    const startTime = performance.now();
    
    // Simulate processing
    const processedEvents = rawData.map(event => ({
      ...event,
      id: `test-${Math.random()}`,
      categoryPrimary: 'Test',
      categorySecondary: 'Test'
    }));
    
    const endTime = performance.now();
    const duration = endTime - startTime;
    
    console.log(`Processing time: ${duration.toFixed(2)}ms`);
    console.log(`Status: ${duration < 1000 ? '✅ FAST' : '⚠️ SLOW'}`);
    
    // Final results
    console.log('\n🎯 TEST RESULTS:');
    console.log('✅ JSON file accessible');
    console.log(`✅ ${rawData.length} events loaded`);
    console.log(`✅ ${Object.keys(formats).length} formats found`);
    console.log(`✅ ${uniqueDates.length} unique dates`);
    console.log(`✅ Processing: ${duration.toFixed(2)}ms`);
    
    return {
      success: true,
      eventCount: rawData.length,
      formats: Object.keys(formats),
      uniqueDates: uniqueDates.length,
      processingTime: duration
    };
    
  } catch (error) {
    console.error('❌ TEST FAILED:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

// Make function available globally
if (typeof window !== 'undefined') {
  window.testFullDatasetLoading = testFullDatasetLoading;
  console.log('🧪 Test function available: testFullDatasetLoading()');
}




